export { default as academyDomain } from "./Academy.domain";
